import { useState, useCallback } from '@wordpress/element';
import api from '../utils/api';

const { __ } = wp.i18n;

export function useAgents() {
    const [agents, setAgents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchAgents = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await api.getAgents();
            setAgents(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, []);

    const createAgent = useCallback(async (agentData) => {
        const agent = await api.createAgent(agentData);
        setAgents((prev) => [agent, ...prev]);
        return agent;
    }, []);

    const updateAgent = useCallback(async (id, agentData) => {
        const agent = await api.updateAgent(id, agentData);
        setAgents((prev) => prev.map((a) => (a.id === id ? agent : a)));
        return agent;
    }, []);

    const deleteAgent = useCallback(async (id) => {
        await api.deleteAgent(id);
        setAgents((prev) => prev.filter((a) => a.id !== id));
    }, []);

    const toggleAgent = useCallback(async (id) => {
        const result = await api.toggleAgent(id);
        setAgents((prev) =>
            prev.map((a) =>
                a.id === id
                    ? { ...a, status: result.status, active: result.active }
                    : a
            )
        );
        return result;
    }, []);

    const runAgent = useCallback(async (id) => {
        return await api.runAgent(id);
    }, []);

    const duplicateAgent = useCallback(async (id) => {
        const agent = await api.duplicateAgent(id);
        setAgents((prev) => [agent, ...prev]);
        return agent;
    }, []);

    return {
        agents,
        loading,
        error,
        fetchAgents,
        createAgent,
        updateAgent,
        deleteAgent,
        toggleAgent,
        runAgent,
        duplicateAgent,
    };
}
